import { lazy } from 'react';
import Loadable from 'components/Loadable';
import DefaultLayout from 'layout/Default';
import { ProtectedRoute } from 'routes/RouteGuards';

const ManageOutletsPage = Loadable(
  lazy(() => import('views/outlets/ManageOutlets'))
);

const ManageOutletslabsPage = Loadable(
  lazy(() => import('views/outlets/ManageOutletslabs'))
);

const OutletsRoutes = {
  path: '/',
  element: <ProtectedRoute />,
  children: [
    {
      element: <DefaultLayout />,
      children: [
        {
          path: 'manage-outlets',
          element: <ManageOutletsPage />
        },
        {
          path: 'manage-outlets-labs',
          element: <ManageOutletslabsPage />
        }
      ]
    }
  ]
};

export default OutletsRoutes;
